import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {filter, map} from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import {AccountService} from "../../services";
import {CardStatsList} from "../../models/cardStatsList";
import {CardStats} from "../../models/cardStats";

@Injectable({ providedIn: 'root' })
export class CardStatsService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    getAllByCard(offset: number, limit: number, cardUuid: string) {
        return this.http.get<CardStatsList>(`${environment.apiEndpoint}/v1/card/stats/` + cardUuid + `?offset=`+offset+`&limit=`+limit, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getByUuid(cardUuid: string, uuid: string) {
        return this.http.get<CardStats>(`${environment.apiEndpoint}/v1/card/${cardUuid}/stats/${uuid}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }
}
